import { z } from 'zod';
import { requiredString } from '../helpers';
export const Salesforce_Get_Contact_1_ConfigValidator = z.object({
    connection: requiredString('Salesforce Connection is required'),
    contactId: requiredString('Contact ID is required'),
    customFields: z.string().optional(),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true;
        try {
            JSON.parse(val);
            return true;
        }
        catch {
            return false;
        }
    }, { message: 'Expected output must be valid JSON' })
});
//# sourceMappingURL=salesforce-get-contact-1.js.map